import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {costs} from './defaultResponseModel/costs';
const FUNCTION_CODE = 'GET_ADMIN_DASHBOARD_COSTS';

export async function getCosts(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/partner/costs/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return costs.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
